import { useEffect, useMemo, useState } from "react";
import DealFieldsProvider from "../services/dealFieldsProvider";
import PipedriveApiService from "../services/pipedriveApiService";

export default function usePipedrivePersonSearch(query: string): string[] {
    const pipedriveApiService = useMemo(() => new PipedriveApiService(new DealFieldsProvider()), []);
    const [searchResult, setSearchResult] = useState<string[]>([]);

    useEffect(() => {
        setSearchResult([]);
        if (query.length < 3) {
            return;
        }

        let isRequestCancelled = false;
        pipedriveApiService.searchPersons(query)
            .then(persons => !isRequestCancelled && setSearchResult(persons.map(o => o.name)));

        return () => {
            isRequestCancelled = true;
        };
    }, [query]);

    return searchResult;
}